"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayTemplate = void 0;
function StringArrayTemplate() {
    return `
        const {stringArrayName} = [{stringArrayStorageItems}];
    `;
}
exports.StringArrayTemplate = StringArrayTemplate;
